"use strict";

/**
 * @typedef URLParam URLパラメータオブジェクト
 * @type {Object}
 * @property {string} hash
 * @property {string} host
 * @property {string} hostname
 * @property {string} href
 * @property {string} pathname
 * @property {string} port
 * @property {string} protocol
 * @property {string} search
 * @property {SearchParam} param
 */

/**
 * グローバルオブジェクトを取得する
 * @description クロージャシングルトンで実装しているので気軽にコールできます
 * @return {Function}
 */
const getGlobal = (
	/** 即時実行 */
	function ()
	{
		/**
		 * グローバルオブジェクト
		 * @type {Window} global
		 * @description strict modeはFunctionコンストラクタまで伝搬せず、スコープ非依存でstrict modeの影響も受けない
		 */
		const global = Function( 'return this' )();

		return function ()
		{
			return global;
		}
	})();

/**
 * メモリキャッシュ化したDOMリストを返します
 * @description 引数にDOMオブジェクトをつっこむようなjQueryセレクタには非対応。なのでstring型チェック
 */
const $$ = (
	/** 即時実行 */
	function ()
	{
		return _.memoize(
			/**
			 * @param {string} _tag セレクタ
			 * @param {string} _base セレクタ
			 * @return {JQuery}
			 */
			function (_tag, _base = null)
				{
					if( _.isString( _tag ) && _.isString( _base ) )
					{
						return $.call(null, _tag, $$(_base) ); //再帰でキャッシュ作成
					}
					else if( _.isString( _tag ) )
						return $.call(null, _tag);
					else
						throw new Error('type error : only string type arguments');
				},
			/**
			 * @param {string} _tag
			 * @param {string} _base
			 */
			function resolver(_tag, _base = null)
				{
					// キャッシュキー自分で作ります
					const isTag = _.isString(_tag) && _.size( _tag );
					let key = '';

					if( isTag && _.isString( _base ) )
						key = `${_tag}:::${_base}`; //jQueryでエスケープしないと使えない文字列を識別子に
					else if( isTag )
						key = _tag;
					else
						key= Math.random().toString();

					return key;
				}
		);
	})();



//――――――――――――――――――――――――――
// console implementation for IE
// 使い方 log('hogehoge') 等
//――――――――――――――――――――――――――
( function ( global )
{ //即時関数

	// デバッグモード切替
	//var debug = true;

	//古いIEを黙らせる用
	if ( !global.console )
	{
		global.console = {};
		global.console.log = function () { };
	}

	/**
	 *	console.error For not implemented Browser
	 */
	if ( !global.console.error )
	{
		global.console.error = global.console.log;
	}

	/**
	 *	console.timer For not implemented Browser
	 */
	if ( !global.console.time )
	{
		global.console.time = function ( key )
		{
			global.time || ( global.time = {});
			global.time[ key ] = new Date().getTime();
		};

		global.console.timeEnd = function ( key )
		{
			global.time || ( global.time = {});
			var processTime = +new Date() - global.time[ key ];
			global.console.log( "Time " + key + ":" + processTime + "msec" );
			delete global.time[ key ];
		};
	}

	/**
	 * タイトルログ出力
	 * @param {array} args
	 */
	global.console.title = function ( ...args )
	{
		if( $.UA.IE ) return ;
		const deco = _.isString(this) ? this : '-';
		const title = _.first(args);

		if( _.isString( title ) )
		{
			console.log( _.pad( ` ${title} ` , 70, deco ) );

			if(_.size( args ) > 1)
				console.log.apply( null, _.tail( args ) );
		}
		else
		{
			console.log.apply( null, args );
		}

	};

	global.error = global.console.error;
	global.time = global.console.time;
	global.timeEnd = global.console.timeEnd;

	if( _.get(global, 'DEBUG_DEBUG', false) )
		global.log = global.console.log
	else
		global.log = function(){};

})( getGlobal() );

//――――――――――――――――――――――――――
// pollyfil
//――――――――――――――――――――――――――
( function ( global, undefined )
{
	/**
	 * 配列を引数の数値単位で分割する
	 * @return {array}
	 * @param {number}
	 */
	Array.prototype.chunk || ( Array.prototype.chunk = function ( size )
	{
		var array = this;
		return [].concat.apply( [], array.map( function ( e, idx )
		{
			return idx % size ? [] : [ array.slice( idx, idx + size ) ];
		}) );
	});

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//Mathにdegrees関数が標準で入ってないので
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	Math.degrees = Math.degrees || ( function ()
	{
		var toDegree = 180 / Math.PI;
		return function ( radian )
		{
			if ( isNaN( radian ) )
			{
				return NaN;
			}
			return radian * toDegree;
		}
	})();

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	// IE8以前のsubstrは負の値は0扱いとなり他のブラウザと挙動が違う対応
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	if ( 'ab'.substr( -1 ) != 'b' )
	{
		String.prototype.substr = function ( substr )
		{
			return function ( start, length )
			{
				if ( start < 0 ) start = this.length + start;
				return substr.call( this, start, length );
			}
		} ( String.prototype.substr );
	}

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	if ( typeof Number.isFinite === 'undefined' ) //for IE
		Number.isFinite = Number.isFinite || function ( any )
		{
			return typeof any === 'number' && isFinite( any );
		};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	if ( typeof Number.isNaN === 'undefined' ) //for IE
		Number.isNaN = Number.isNaN || function ( any )
		{
			return typeof any === 'number' && isNaN( any );
		};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//String#contains - 引数の文字列が含まれているか（単純正規表現記述に対応するように拡張）
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	String.prototype.contains = function contains( _contains )
	{
		return function ( searchString, position )
		{
			if ( searchString != undefined && searchString.constructor === RegExp )
			{
				return searchString.test( this.slice( position ) );
			}
			else
			{
				return _contains.call( this, searchString, position );
			}
		}
	} ( String.prototype.contains );

})( getGlobal() );

window.matchMedia || (window.matchMedia = function() {
    "use strict";

    // For browsers that support matchMedium api such as IE 9 and webkit
    var styleMedia = (window.styleMedia || window.media);

    // For those that don't support matchMedium
    if (!styleMedia) {
        var style       = document.createElement('style'),
            script      = document.getElementsByTagName('script')[0],
            info        = null;

        style.type  = 'text/css';
        style.id    = 'matchmediajs-test';

        if (!script) {
          document.head.appendChild(style);
        } else {
          script.parentNode.insertBefore(style, script);
        }

        // 'style.currentStyle' is used by IE <= 8 and 'window.getComputedStyle' for all other browsers
        info = ('getComputedStyle' in window) && window.getComputedStyle(style, null) || style.currentStyle;

        styleMedia = {
            matchMedium: function(media) {
                var text = '@media ' + media + '{ #matchmediajs-test { width: 1px; } }';

                // 'style.styleSheet' is used by IE <= 8 and 'style.textContent' for all other browsers
                if (style.styleSheet) {
                    style.styleSheet.cssText = text;
                } else {
                    style.textContent = text;
                }

                // Test if media query is true or false
                return info.width === '1px';
            }
        };
    }

    return function(media) {
        return {
            matches: styleMedia.matchMedium(media || 'all'),
            media: media || 'all'
        };
    };
}());

//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// closest pollyfil
//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
if (window.Element && !Element.prototype.closest) {
    Element.prototype.closest = 
    function(s) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(s),
            i,
            el = this;
        do {
            i = matches.length;
            while (--i >= 0 && matches.item(i) !== el) {};
        } while ((i < 0) && (el = el.parentElement)); 
        return el;
    };
}

//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// Web Storage pollyfil
//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
( function ( global, undefined )
{
	if ( !global.sessionStorage )
	{
		global.sessionStorage = {
			length: 0,
			setItem: function ( key, value )
			{
				document.cookie = key + '=' + value + '; path=/';
				this.length++;
			},
			getItem: function ( key )
			{
				var keyEQ = key + '=';
				var ca = document.cookie.split( ';' );
				for ( var i = 0, len = ca.length; i < len; i++ )
				{
					var c = ca[ i ];
					while ( c.charAt( 0 ) === ' ' ) c = c.substring( 1, c.length );
					if ( c.indexOf( keyEQ ) === 0 ) return c.substring( keyEQ.length, c.length );
				}
				return null;
			},
			removeItem: function ( key )
			{
				this.setItem( key, '', -1 );
				this.length--;
			},
			clear: function ()
			{
				// Caution: will clear all persistent cookies as well
				var ca = document.cookie.split( ';' );
				for ( var i = 0, len = ca.length; i < len; i++ )
				{
					var c = ca[ i ];
					while ( c.charAt( 0 ) === ' ' ) c = c.substring( 1, c.length );
					var key = c.substring( 0, c.indexOf( '=' ) );
					this.removeItem( key );
				}
				this.length = 0;
			},
			key: function ( n )
			{
				var ca = document.cookie.split( ';' );
				if ( n >= ca.length || isNaN( parseFloat( n ) ) || !isFinite( n ) ) return null;
				var c = ca[ n ];
				while ( c.charAt( 0 ) === ' ' ) c = c.substring( 1, c.length );
				return c.substring( 0, c.indexOf( '=' ) );
			}
		}
	};

	if ( !window.localStorage )
	{
		window.localStorage = {
			getItem: function ( sKey )
			{
				if ( !sKey || !this.hasOwnProperty( sKey ) ) { return null; }
				return unescape( document.cookie.replace( new RegExp( "(?:^|.*;\\s*)" + escape( sKey ).replace( /[\-\.\+\*]/g, "\\$&" ) + "\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*" ), "$1" ) );
			},
			key: function ( nKeyId )
			{
				return unescape( document.cookie.replace( /\s*\=(?:.(?!;))*$/, "" ).split( /\s*\=(?:[^;](?!;))*[^;]?;\s*/ )[ nKeyId ] );
			},
			setItem: function ( sKey, sValue )
			{
				if ( !sKey ) { return; }
				document.cookie = escape( sKey ) + "=" + escape( sValue ) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/";
				this.length = document.cookie.match( /\=/g ).length;
			},
			length: 0,
			removeItem: function ( sKey )
			{
				if ( !sKey || !this.hasOwnProperty( sKey ) ) { return; }
				document.cookie = escape( sKey ) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/";
				this.length--;
			},
			hasOwnProperty: function ( sKey )
			{
				return ( new RegExp( "(?:^|;\\s*)" + escape( sKey ).replace( /[\-\.\+\*]/g, "\\$&" ) + "\\s*\\=" ) ).test( document.cookie );
			}
		};
		window.localStorage.length = ( document.cookie.match( /\=/g ) || window.localStorage ).length;
	}
})( getGlobal() );

if ( !HTMLFormElement.prototype.reportValidity ) {
    HTMLFormElement.prototype.reportValidity = function() {
        var submitButtons = this.querySelectorAll( "button, input[type=submit]" );
        for ( var i = 0; i < submitButtons.length; i++ ) {
            if ( submitButtons[ i ].type === "submit" ) {
                submitButtons[ i ].click();
                return;
            }
        }
    }
}

/**
 * IEやedgeは未対応なので
 */
if ( !HTMLInputElement.prototype.reportValidity )
{
	HTMLInputElement.prototype.reportValidity = jQuery.noop;
}


//オブジェクトの差分抽出関数
( function ( global, undefined )
{
	global.diff = function diff()
	{
		function isStrictEqual( a, b )
		{
			return a === b;
		}

		function main( opts, subjects )
		{
			const length = subjects.length;
			const ref = subjects[ 0 ];
			const diff = {};
			const equal = opts && opts.equal || isStrictEqual;
			let c;
			let keys;
			let keysLength;
			let key;
			let u;

			for ( let i = 1; i < length; i++ )
			{
				c = subjects[ i ];
				keys = Object.keys( c );
				keysLength = keys.length;

				for ( u = 0; u < keysLength; u++ )
				{
					key = keys[ u ];

					if ( !equal( c[ key ], ref[ key ] ) )
						diff[ key ] = c[ key ];
				}
			}

			return diff;
		}

		return main( null, [].slice.call( arguments, 0 ) );
	};

})( getGlobal() );


const CSSController = (function( global ){

	/**
	 * CSSルールを追加する
	 * @param {string} selector
	 * @param {string} styleName
	 * @param {string|number} value
	 * @param {string} media
	 */
	function addRule( selector, styleName, value, media )
	{
		const sheet = setSheet( media );
		
		if ( sheet.addRule )
		{ // IE
			sheet.addRule( selector, styleName + ":" + value, sheet.rules.length );
		}
		else if ( sheet.insertRule )
		{ // !IE
			const rule = selector + "{" + styleName + ":" + value + "}";
			const index = sheet.cssRules.length;
			sheet.insertRule( rule, index );
		}
	};

	// メディアクエリのテキストをキーとして，シートを管理している
	const sheets = {};
	function setSheet( media = 0 )
	{
		const sheet = _.get( sheets, media );
		if ( !sheet )
		{
			const style = document.createElement( "style" );
			if ( media )
			{
				style.setAttribute( "media", media ); // mediaクエリをセット
			}
			document.getElementsByTagName( "head" )[ 0 ].appendChild( style );
			sheets[ media ] = style.sheet;
			return style.sheet;
		}
		return sheet;
	}

	return {
		addRule : addRule,
	}
})( getGlobal() );

/* jQuery Tap Event */
(function($, window) {
	"use strict";

	var RANGE = 5,
		events = ["click", "touchstart", "touchmove", "touchend"],
		handlers = {
			click: function(e) {
				if(e.target === e.currentTarget)
					e.preventDefault();
			},
			touchstart: function(e) {
				this.jQueryTap.touched = true;
				this.jQueryTap.startX = e.touches[0].pageX;
				this.jQueryTap.startY = e.touches[0].pageY;
			},
			touchmove: function(e) {
				if(!this.jQueryTap.touched) {
					return;
				}

				if(Math.abs(e.touches[0].pageX - this.jQueryTap.startX) > RANGE ||
				   Math.abs(e.touches[0].pageY - this.jQueryTap.startY) > RANGE) {
					this.jQueryTap.touched = false;
				}
			},
			touchend: function(e) {
				if(!this.jQueryTap.touched) {
					return;
				}

				this.jQueryTap.touched = false;
				$.event.dispatch.call(this, $.Event("tap", {
					originalEvent: e,
					target: e.target,
					pageX: e.changedTouches[0].pageX,
					pageY: e.changedTouches[0].pageY
				}));
			}
		};

	$.event.special.tap = "ontouchend" in window? {
		setup: function() {
			var thisObj = this;
			
			if(!this.jQueryTap) {
				Object.defineProperty(this, "jQueryTap", {value: {}});
			}
			$.each(events, function(i, ev) {
				thisObj.addEventListener(ev, handlers[ev], false);
			});
		},
		teardown: function() {
			var thisObj = this;
			
			$.each(events, function(i, ev) {
				thisObj.removeEventListener(ev, handlers[ev], false);
			});
		}
	}: {
		bindType: "click",
		delegateType: "click"
	};

	$.fn.tap = function(data, fn) {
		return arguments.length > 0? this.on("tap", null, data, fn): this.trigger("tap");
	};
})(jQuery, getGlobal());

( function ( global, factory, undefined )
{
	/**
	 * @type {JQueryStatic}
	 */
	const $ = global.$;
	const implement = factory( global, $ );

	/*********************************************************
	 ********** 基本オブジェクトのprototype拡張定義 **********
	 *********************************************************/
	Array.prototype.chunk = implement.array.chunk;		//配列の行列分割
	String.prototype.replaceAll = implement.string.replaceAll;	//全置換：全ての文字列 org を dest に置換
	String.prototype.len = implement.string.len;		//UTF-16のサロゲートペア文字に対応した文字数カウントメソッド
	String.prototype.trim = implement.string.trim;		//全角対応 trim()
	String.prototype.boolean = implement.string.boolean;	//String型→Boolean型 対応文字列：'true'/'false', 'yes'/'no', '1'/'0', 'null'
	String.prototype.capitalize = implement.string.capitalize;	//先頭を大文字、それ以降を小文字にする
	String.prototype.zero = implement.string.zero;		//ゼロパディングString版  例："123".zero(10) → '0000000123';
	String.prototype.idEsc = implement.string.idEsc;		//jQuery用セレクタ文字列退避用
	String.prototype.toHan = implement.string.toHan;		//半角にする( Unicode用 )
	String.prototype.toZen = implement.string.toZen;		//全角にする( Unicode用 )
	String.prototype.toKatakana = implement.string.toKatakana;	//平仮名をカタカナにする
	String.prototype.toInt = implement.string.toInt;		//数値へ変換  例："123".toInt();
	String.prototype.rgb2hex = implement.string.rgb2hex;	//"rgb(255,255,255)".rgb2hex() で String(FFFFFF)を返す。"rgba(255,255,255,0.5)".rgb2hex() で FFFFFFと透明度情報(opacityとalpha)を付加してStringを返す。
	String.prototype.htmlEscape = implement.string.htmlEscape;	//HTMLエスケープ
	String.prototype.htmlUnescape = implement.string.htmlUnescape;//HTMLアンエスケープ（タグに戻す）
	String.prototype.datasize = implement.string.datasize;	//ファイルサイズ容量に変換
	String.prototype.formatZip = implement.string.formatZip;	//郵便番号にハイフン付にする
	String.prototype.valZip = implement.string.valZip;		//郵便番号からハイフンをトル
	String.prototype.formatTel = implement.string.formatTel;	//電話番号をハイフン付にする
	String.prototype.isTel = implement.string.isTel;		//電話番号判定
	String.prototype.splitExt = implement.string.splitExt;	//ファイル名を拡張子とそれ以外に分ける用
	String.prototype.mime2ext = implement.string.mime2ext;	//MIME TYPEから拡張子を求める
	String.prototype.removeTag = implement.string.removeTag;	//タグ除去
	Number.prototype.zero = implement.number.zero;		//ゼロパディングNumber版  例：new Number(123).zero(10);
	Number.prototype.datasize = implement.number.datasize;	//ファイルサイズ容量表示
	Number.prototype.format = implement.number.format;		//カンマ区切りの数値フォーマットに変換


	/****************************************************
	 ********** グローバル関数・エイリアス定義 **********
	 ****************************************************/
	global.nvl = implement.global.nvl;			//OracleのNVL 可変長引数対応
	global.zero = implement.global.zero;			//カンマ区切りの数値フォーマットに変換
	global.toInt = implement.global.toInt;			//カンマ区切りの数値フォーマットに変換
	global.formatNum = implement.global.formatNum;		//カンマ区切りの\マーク表記に変換
	global.formatYen = implement.global.formatYen;		//カンマ区切りの○○○円表記に変換
	global.formatYenMark = implement.global.formatYenMark;	//カンマ区切りの\○○○表記に変換
	global.formatYmd = implement.global.formatYmd;		//年月日整形ラッパー (要moment.js)
	global.formatZip = implement.global.formatZip;		//郵便番号にハイフン整形ラッパー
	global.valZip = implement.global.valZip;			//郵便番号のハイフン除去ラッパー
	global.toZen = implement.global.toZen;			//全角にする( Unicode用 )ラッパー
	global.formatTel = implement.global.formatTel;		//電話番号をハイフン付ラッパー
	global.formatPercent = implement.global.formatPercent;	//パーセント表記ラッパー
	global.wrapText = implement.global.wrapText;		//正規表現に一致するテキストをタグではさむ関数
	global.removeTag = implement.global.removeTag;		//タグ除去
	global.serialize = implement.global.serialize;		//オブジェクトをGETパラメータ文字列にシリアライズ。オプションでJSONにも変換可能
	global.is = implement.global.is;				//型比較
	global.isTel = implement.global.isTel;			//電話番号判定
	global.Ajax = implement.ajax;				//$.Deferred対応Ajaxオブジェクト
	global.App = implement.Application;				//アプリケーション特有のオブジェクト
	global.loadingStart = implement.loadingStart;		//$.Deferred対応ローディング開始
	global.loadingEnd = implement.loadingEnd;		//$.Deferred対応ローディング終了
	global.SyncGroup = implement.SyncGroup;			//複数の入力項目で同期させるオブジェクト
	global.toLowerProp = implement.toLowerProp;		//破壊的なプロパティ名の大文字→小文字変換
	global.forceLayout = implement.forceLayout;		//ブラウザにたまったDOM変更を適用させる
	global.Boolean.val = implement.boolean.val;		//ただの静的関数として利用 Boolean.val( 'true' )

	//――――――――――――――――――――――――――
	// jQuery拡張
	//――――――――――――――――――――――――――
	$.extend(
		{
			UA: implement.jquery.UA,					//クライアント環境判定
			uri: implement.jquery.uri,					//URLパース
			noopScroll: implement.jquery.noopScroll,	//スクロール時にページ内のマウスオーバーイベントをブロック（描画負荷軽減＆邪魔なインラインスクロール無視）
			//nvl: implement.jquery.nvl,					//NVL関数  $.nvl( A, B, C, D, 'default' )
			getLang: implement.jquery.getLang,				//ブラウザの言語情報 * RFC 4646の先頭2文字(ISO 639)を取得
			isFirstAccess: implement.jquery.isFirstAccess,		//初回アクセス判定
			setSession: implement.jquery.setSession,			//セッション管理用 html5::sessionStorageを使っているのでスマホのWEBアプリでも使える。非対応の端末・ブラウザではcookie
			getSession: implement.jquery.getSession,			//セッション管理用
			async: implement.jquery.async,				//高速非同期呼び出し 使い方：$.async( func );
			alert: implement.jquery.alert,				//あんまり意味ないヤツ。きれいなモーダルUIで実装してもスレッドは止まらないしね。
			beforeunload: implement.jquery.beforeunload,			//ページ離脱処理（ブラウザ閉じたり、ページを離れる時に表示するアラートメッセージを仕込む）
			execBeforeUnload: implement.jquery.execBeforeUnload,		//ページ離脱処理フラグ
			cancelBeforeUnload: implement.jquery.cancelBeforeUnload,	//ページ離脱処理を一時的にキャンセル
			sleep: implement.jquery.sleep,				//$.Deferred対応sleep
			checkTel: implement.jquery.checkTel,				//電話番号チェック(Deferred版)
			preloadImages: implement.jquery.preloadImages,		//
			eventStop: implement.jquery.eventStop,
		});

	//jQueryプラグイン
	$.fn.extend(
		{
			isVisible: implement.jquery.fn.isVisible,		//描画要素なのか判定
			clearForm: implement.jquery.fn.clearForm,		//フォームをクリア（リセットではなく）
			disabled: implement.jquery.fn.disabled,		//対象要素内のインプット要素を全てdisabledに
			readonly: implement.jquery.fn.readonly,		//対象要素内のインプット要素を全てreadonlyに
			nvl: implement.jquery.fn.nvl,			//val()のnvl
			selfHtml: implement.jquery.fn.selfHtml,		//自分自身のタグを取得
		});

})( getGlobal(),
/**
 * @param {Window} global
 * @param {JQueryStatic} $
 */
function factory( global, $ )
{
	'use strict';
	//――――――――――――――――――――――――――
	// 実装
	//――――――――――――――――――――――――――

	//名前空間
	const implement = {
		global: {},
		jquery: {},
		array: {},
		string: {},
		number: {},
		boolean: {},
		date: {},
		math: {},
		ajax: {},
		app: {},
	};

	/****************************************************
	 ********** グローバル関数・エイリアス実装 **********
	 ****************************************************/
	implement.global.nvl = function ()
	{
		for ( var i = 0, len = arguments.length; i < len; i++ )
		{
			if ( typeof arguments[ i ] === 'string' && arguments[ i ].trim() != '' )
				return arguments[ i ];
			else if ( typeof arguments[ i ] === 'boolean' )
				return arguments[ i ];
			else if ( typeof arguments[ i ] === 'number' )
				return arguments[ i ];
			else if ( typeof arguments[ i ] === 'object' && arguments[ i ] )
			{
				try
				{
					var value = arguments[ i ].toString().trim();
					if ( value != '' ) return value;
				}
				catch ( err ) { }
			}
		}
		return '';
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	// ゼロパディング関数版  例：zero(123,10);
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.global.zero = function ( target, len )
	{
		return new String( target ).zero( len );
	};

	implement.global.toInt = function ( value, def )
	{
		if ( def === undefined ) def = 0;
		if ( !Number.isFinite( def ) ) def = NaN;
		var i = parseInt( value, 10 );
		if ( Number.isFinite( i ) )
			return i;
		else
			return def;
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	// カンマ区切りの数値フォーマットに変換
	// 第二引数にcallback的なの渡せます。
	// 	例:
	// 	formatNum( 245000, function ( _value, _str )
	// 	{
	// 		if( _value < 0 )
	// 			return '<span style="color:red;">' + _str + '</span>';
	// 		else
	// 			return _str;
	// 	});
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.global.formatNum = function ( value, func )
	{
		try
		{
			var str = Number( value ).format();

			if ( !$.isFunction( func ) )
				func = null; //Functionじゃなかった


			//default処理は「マイナスの場合は赤字」

			if ( func == null )
			{
				func = function ( _value, _str )
				{
					if ( _value < 0 )
					{
						return '<span style="color:red;">' + _str + '</span>';
					}
					else
					{
						return _str;
					}
				}
			}

			return func( value, str );
		} catch ( exp )
		{
			return '---';
		}
	};
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  カンマ区切りの円表記に変換
	//  formatNumと同じように第二引数にcallback的なの渡せます
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.global.formatYen = function ( value, func )
	{
		try
		{
			var str = Number( value ).format() + '円';

			if ( !$.isFunction( func ) )
				func = null; //Functionじゃなかった


			//default処理は「マイナスの場合は赤字」

			if ( func == null )
			{
				func = function ( _value, _str )
				{
					if ( _value < 0 )
						return '<span style="color:red;">' + _str + '</span>';
					else
						return _str;
				}
			}
			return func( value, str );
		} catch ( exp )
		{
			return '--円';
		}
	};
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  カンマ区切りの\マーク表記に変換
	//  formatNumと同じように第二引数にcallback的なの渡せます
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.global.formatYenMark = function ( value, func )
	{
		if ( value === false || value === null || Number.isNaN( value ) ) return '';
		var _func = func;

		if ( !$.isFunction( _func ) )
			_func = null; //Functionじゃなかった

		//default処理は「マイナスの場合は赤字」
		if ( _func == null )
		{
			_func = function ( _value, _str )
			{
				if ( _value < 0 )
					return '<span style="color:red;">' + _str + '</span>';
				else
					return _str;
			}
		}

		try
		{
			return _func( value, '&yen;' + Number( value ).format() );
		} catch ( exp )
		{
			return '';
		}
	}
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  年月日整形ラッパー (要moment.js)
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.global.formatYmd = function ( format, value )
	{
		if ( value )
			return moment( value ).format( format );
		else
			return '';
	}
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  郵便番号にハイフンを入れるメソッドのラッパー関数
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.global.formatZip = function ( value )
	{
		try
		{
			return value.formatZip();
		} catch ( exp )
		{
			return value;
		}
	};
	implement.global.valZip = function ( value )
	{
		try
		{
			return value.valZip();
		} catch ( exp )
		{
			return value;
		}
	};
	implement.global.toZen = function ( value )
	{
		try
		{
			return value.toZen();
		} catch ( exp )
		{
			return '';
		}
	};
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  電話番号をハイフン付にするメソッドのラッパー関数
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.global.formatTel = function ( value )
	{
		try
		{
			return value.formatTel();
		} catch ( exp )
		{
			return value;
		}
	};
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  正規表現に一致するテキストをタグではさむ関数
	//   (テキストをハイライト表示させたりする時)
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.global.wrapText = function ( textNode, tag, begin, end )
	{
		// タグで挟む部分より前のテキストを新しいテキスト ノードにして textNode の前に挿入
		var fore = document.createTextNode( textNode.nodeValue.substring( 0, begin ) );
		textNode.parentNode.insertBefore( fore, textNode );

		// タグで挟む部分を新しい要素にして textNode の前に挿入
		var wrapped = document.createElement( tag );
		wrapped.appendChild( document.createTextNode( textNode.nodeValue.substring( begin, end ) ) );
		textNode.parentNode.insertBefore( wrapped, textNode );

		// textNode の内容からタグで挟んだ部分までを削除
		textNode.nodeValue = textNode.nodeValue.substring( end );
		return wrapped;
	};
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  タグ除去
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.global.removeTag = function ( text )
	{
		return text.removeTag();
	};
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  オブジェクトをGETパラメータ文字列にシリアライズ。オプションでJSONにも変換可能
	//  serialize( form );
	//  $("form").serialize()を使ってもいいかも
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.global.serialize = function ( obj, options )
	{
		var def = { mode: 'GET' };
		var opt = $.extend( true, {}, def, options );
		if ( !obj ) return '';
		if ( 'JSON' == opt.mode.toUpperCase() )
		{
			if ( JSON.stringify )
				return JSON.stringify( obj );
			return this;
		}
		else // if( 'GET' == opt.mode.toUpperCase() )
		{
			var str = '', amp = '';
			for ( var _key in obj )
			{
				if ( obj.hasOwnProperty( _key ) && nvl( obj[ _key ], false ) != false ) //ES6ならObject.keys(o).forEach(function(key)
				{
					str += amp + _key + "=" + encodeURIComponent( obj[ _key ] );
					amp = '&';
				}
			}
			return str;
		}
	}

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  正しい電話番号フォーマットか判定（ハイフンありなし両対応）
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.global.isTel = function ( options )
	{
		//デフォルトオプション
		var def = {
			value: ''
			, checkDash: true //ハイフン正規化を行うか

		};

		//引数をvalueとしてチェックする
		if ( $.type( options ) !== 'object' )
			options = { value: options };

		//オプションを取得する
		var opt = $.extend( true, {}, def, options );
		return opt.value.isTel( options );
	};
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  型比較
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.global.is = function ( type, obj )
	{
		var clas = Object.prototype.toString.call( obj ).slice( 8, -1 );
		return obj !== undefined && obj !== null && clas === type;
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -~~~~~~~~~~~~~~~~~~~~
	// 全置換：全ての文字列 org を dest に置換
	// "javascript".replaceAll('a','*') → "j*v*script"
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -____________________
	implement.string.replaceAll = function ( org, dest )
	{
		if ( typeof org == 'string' )
			return this.split( org ).join( dest ) + '';
		else
			return this.replace( org, dest ); // replace() と同じエラーで返す
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -~~~~~~~~~~~~~~~~~~~~
	// UTF-16のサロゲートペア文字に対応した文字数カウントメソッド
	// "𠮷野家で𩸽".len(); →5文字
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -____________________
	implement.string.len = function ()
	{
		return this.length - ( this.match( /[\uD800-\uDBFF][\uDC00-\uDFFF]/g ) || [] ).length;
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  全角対応 trim()   例：' 　test 　hoge 　　 '.trim() → 'test 　hoge'
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.string.trim = function ()
	{
		return this.replace( /^[\s　]+|[\s　]+$/g, '' );
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  String型→Boolean型
	//  対応文字列：true/false, yes/no, 1/0, null
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.string.boolean = function ()
	{
		if ( !this ) return false;
		switch ( this.toLowerCase() )
		{
			case 'true': case 'yes': case 'ok': case '1': case 'up': case 'open': case 'good': case 'allow': case 'win': case 'success': case 'はい': case '１': return true;
			case 'false': case 'no': case 'ng': case '0': case 'down': case 'close': case 'bad': case 'deny': case 'lose': case 'fail': case 'いいえ': case '０': case 'null': case 'undefined': return false;
			default: return true;
		}
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  先頭を大文字、それ以降を小文字にする
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.string.capitalize = function ()
	{
		return this.toLowerCase().replace( /(^\w{1}|\s{1}\w{1})/g, function ( $0 ) { return $0.toUpperCase(); });
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  ゼロパディングString版  例："123".zero(10) → '0000000123';
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.string.zero = function ()
	{
		if ( arguments.length )
		{
			// 桁数と文字数の差を計算します。
			var str = this.trim();
			var cnt = arguments[ 0 ] - str.length;
			for ( var i = 1; i <= cnt; i++ )
				str = '0' + str;
			return str;
		}
		else
		{
			var str = this.trim();
			return str.replace( /^0+([0-9]+)/, "$1" );
		}
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  jQuery用セレクタ文字列退避 $id();で使用
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.string.idEsc = function ()
	{
		return this.replace( /(.{1})(#)/g, "$1\\#" )
			.replaceAll( '[', '\\[' )
			.replaceAll( ']', '\\]' )
			.replaceAll( '*', '\\*' )
			.replaceAll( '=', '\\=' )
			.replaceAll( '+', '\\+' )
			.replaceAll( '-', '\\-' )
			.replaceAll( '~', '\\~' )
			.replaceAll( '"', '\\"' )
			.replaceAll( "'", "\\'" );
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  半角にする( Unicode用 )
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.string.toHan = function ()
	{
		return this.replace( /[！-～]/g, function ( s )
		{
			return String.fromCharCode( s.charCodeAt( 0 ) - 0xFEE0 );
		});
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  電話番号チェック（ハイフンありなし両対応）

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.string.isTel = function ( options )
	{
		if ( nvl( this, false ) === false ) return null;

		//デフォルトオプション
		var def = {
			checkDash: true //ハイフン正規化を行うか

		};

		//オプションを取得する

		var opt = $.extend( true, {}, def, options );

		//ハイフン削除
		var nums = this.trim().replace( /-/g, "" );

		//桁数チェック
		if ( nums.length == 10 || nums.length == 11 )
		{
			//数字頭のチェック
			if ( nums.match( /^0/ ) )
			{
				var data = [ { "o": 9969, "f": 0 }, { "o": 9913, "f": 0 }, { "o": 9912, "f": 0 }, { "o": 9802, "f": 0 }, { "o": 9496, "f": 0 }, { "o": 8514, "f": 0 }, { "o": 8512, "f": 0 }, { "o": 8477, "f": 0 }, { "o": 8396, "f": 0 }, { "o": 8388, "f": 0 }, { "o": 8387, "f": 0 }, { "o": 7468, "f": 0 }, { "o": 5979, "f": 0 }, { "o": 5769, "f": 0 }, { "o": 4998, "f": 0 }, { "o": 4996, "f": 0 }, { "o": 4994, "f": 0 }, { "o": 4992, "f": 0 }, { "o": 1658, "f": 0 }, { "o": 1656, "f": 0 }, { "o": 1655, "f": 0 }, { "o": 1654, "f": 0 }, { "o": 1648, "f": 0 }, { "o": 1635, "f": 0 }, { "o": 1634, "f": 0 }, { "o": 1632, "f": 0 }, { "o": 1587, "f": 0 }, { "o": 1586, "f": 0 }, { "o": 1564, "f": 0 }, { "o": 1558, "f": 0 }, { "o": 1547, "f": 0 }, { "o": 1466, "f": 0 }, { "o": 1457, "f": 0 }, { "o": 1456, "f": 0 }, { "o": 1398, "f": 0 }, { "o": 1397, "f": 0 }, { "o": 1392, "f": 0 }, { "o": 1377, "f": 0 }, { "o": 1374, "f": 0 }, { "o": 1372, "f": 0 }, { "o": 1267, "f": 0 }, { "o": 997, "f": 0 }, { "o": 996, "f": 0 }, { "o": 995, "f": 0 }, { "o": 994, "f": 0 }, { "o": 993, "f": 0 }, { "o": 990, "f": 1 }, { "o": 987, "f": 0 }, { "o": 986, "f": 0 }, { "o": 985, "f": 0 }, { "o": 984, "f": 0 }, { "o": 983, "f": 0 }, { "o": 982, "f": 0 }, { "o": 980, "f": 0 }, { "o": 979, "f": 0 }, { "o": 978, "f": 0 }, { "o": 977, "f": 0 }, { "o": 974, "f": 0 }, { "o": 973, "f": 0 }, { "o": 972, "f": 0 }, { "o": 969, "f": 0 }, { "o": 968, "f": 0 }, { "o": 967, "f": 0 }, { "o": 966, "f": 0 }, { "o": 965, "f": 0 }, { "o": 964, "f": 0 }, { "o": 959, "f": 0 }, { "o": 957, "f": 0 }, { "o": 956, "f": 0 }, { "o": 955, "f": 0 }, { "o": 954, "f": 0 }, { "o": 952, "f": 0 }, { "o": 950, "f": 0 }, { "o": 949, "f": 0 }, { "o": 948, "f": 0 }, { "o": 947, "f": 0 }, { "o": 946, "f": 0 }, { "o": 944, "f": 0 }, { "o": 943, "f": 0 }, { "o": 942, "f": 0 }, { "o": 940, "f": 0 }, { "o": 930, "f": 0 }, { "o": 920, "f": 0 }, { "o": 898, "f": 0 }, { "o": 897, "f": 0 }, { "o": 896, "f": 0 }, { "o": 895, "f": 0 }, { "o": 894, "f": 0 }, { "o": 893, "f": 0 }, { "o": 892, "f": 0 }, { "o": 889, "f": 0 }, { "o": 887, "f": 0 }, { "o": 885, "f": 0 }, { "o": 884, "f": 0 }, { "o": 883, "f": 0 }, { "o": 880, "f": 0 }, { "o": 879, "f": 0 }, { "o": 877, "f": 0 }, { "o": 875, "f": 0 }, { "o": 869, "f": 0 }, { "o": 868, "f": 0 }, { "o": 867, "f": 0 }, { "o": 866, "f": 0 }, { "o": 865, "f": 0 }, { "o": 863, "f": 0 }, { "o": 859, "f": 0 }, { "o": 858, "f": 0 }, { "o": 857, "f": 0 }, { "o": 856, "f": 0 }, { "o": 855, "f": 0 }, { "o": 854, "f": 0 }, { "o": 853, "f": 0 }, { "o": 852, "f": 0 }, { "o": 848, "f": 0 }, { "o": 847, "f": 0 }, { "o": 846, "f": 0 }, { "o": 845, "f": 0 }, { "o": 838, "f": 0 }, { "o": 837, "f": 0 }, { "o": 836, "f": 0 }, { "o": 835, "f": 0 }, { "o": 834, "f": 0 }, { "o": 833, "f": 0 }, { "o": 829, "f": 0 }, { "o": 827, "f": 0 }, { "o": 826, "f": 0 }, { "o": 824, "f": 0 }, { "o": 823, "f": 0 }, { "o": 820, "f": 0 }, { "o": 800, "f": 1 }, { "o": 799, "f": 0 }, { "o": 798, "f": 0 }, { "o": 797, "f": 0 }, { "o": 796, "f": 0 }, { "o": 795, "f": 0 }, { "o": 794, "f": 0 }, { "o": 791, "f": 0 }, { "o": 790, "f": 0 }, { "o": 779, "f": 0 }, { "o": 778, "f": 0 }, { "o": 776, "f": 0 }, { "o": 774, "f": 0 }, { "o": 773, "f": 0 }, { "o": 772, "f": 0 }, { "o": 771, "f": 0 }, { "o": 770, "f": 0 }, { "o": 768, "f": 0 }, { "o": 767, "f": 0 }, { "o": 766, "f": 0 }, { "o": 765, "f": 0 }, { "o": 763, "f": 0 }, { "o": 761, "f": 0 }, { "o": 749, "f": 0 }, { "o": 748, "f": 0 }, { "o": 747, "f": 0 }, { "o": 746, "f": 0 }, { "o": 745, "f": 0 }, { "o": 744, "f": 0 }, { "o": 743, "f": 0 }, { "o": 742, "f": 0 }, { "o": 740, "f": 0 }, { "o": 739, "f": 0 }, { "o": 738, "f": 0 }, { "o": 737, "f": 0 }, { "o": 736, "f": 0 }, { "o": 735, "f": 0 }, { "o": 725, "f": 0 }, { "o": 721, "f": 0 }, { "o": 599, "f": 0 }, { "o": 598, "f": 0 }, { "o": 597, "f": 0 }, { "o": 596, "f": 0 }, { "o": 595, "f": 0 }, { "o": 594, "f": 0 }, { "o": 587, "f": 0 }, { "o": 586, "f": 0 }, { "o": 585, "f": 0 }, { "o": 584, "f": 0 }, { "o": 581, "f": 0 }, { "o": 578, "f": 0 }, { "o": 577, "f": 0 }, { "o": 576, "f": 0 }, { "o": 575, "f": 0 }, { "o": 574, "f": 0 }, { "o": 573, "f": 0 }, { "o": 572, "f": 0 }, { "o": 570, "f": 1 }, { "o": 569, "f": 0 }, { "o": 568, "f": 0 }, { "o": 567, "f": 0 }, { "o": 566, "f": 0 }, { "o": 565, "f": 0 }, { "o": 564, "f": 0 }, { "o": 563, "f": 0 }, { "o": 562, "f": 0 }, { "o": 561, "f": 0 }, { "o": 558, "f": 0 }, { "o": 557, "f": 0 }, { "o": 556, "f": 0 }, { "o": 555, "f": 0 }, { "o": 554, "f": 0 }, { "o": 553, "f": 0 }, { "o": 551, "f": 0 }, { "o": 550, "f": 0 }, { "o": 548, "f": 0 }, { "o": 547, "f": 0 }, { "o": 545, "f": 0 }, { "o": 544, "f": 0 }, { "o": 539, "f": 0 }, { "o": 538, "f": 0 }, { "o": 537, "f": 0 }, { "o": 536, "f": 0 }, { "o": 533, "f": 0 }, { "o": 532, "f": 0 }, { "o": 531, "f": 0 }, { "o": 495, "f": 0 }, { "o": 494, "f": 0 }, { "o": 493, "f": 0 }, { "o": 480, "f": 0 }, { "o": 479, "f": 0 }, { "o": 478, "f": 0 }, { "o": 476, "f": 0 }, { "o": 475, "f": 0 }, { "o": 470, "f": 0 }, { "o": 467, "f": 0 }, { "o": 466, "f": 0 }, { "o": 465, "f": 0 }, { "o": 463, "f": 0 }, { "o": 460, "f": 0 }, { "o": 439, "f": 0 }, { "o": 438, "f": 0 }, { "o": 436, "f": 0 }, { "o": 428, "f": 0 }, { "o": 422, "f": 0 }, { "o": 299, "f": 0 }, { "o": 297, "f": 0 }, { "o": 296, "f": 0 }, { "o": 295, "f": 0 }, { "o": 294, "f": 0 }, { "o": 293, "f": 0 }, { "o": 291, "f": 0 }, { "o": 289, "f": 0 }, { "o": 288, "f": 0 }, { "o": 287, "f": 0 }, { "o": 285, "f": 0 }, { "o": 284, "f": 0 }, { "o": 283, "f": 0 }, { "o": 282, "f": 0 }, { "o": 280, "f": 0 }, { "o": 279, "f": 0 }, { "o": 278, "f": 0 }, { "o": 277, "f": 0 }, { "o": 276, "f": 0 }, { "o": 274, "f": 0 }, { "o": 270, "f": 0 }, { "o": 269, "f": 0 }, { "o": 268, "f": 0 }, { "o": 267, "f": 0 }, { "o": 266, "f": 0 }, { "o": 265, "f": 0 }, { "o": 264, "f": 0 }, { "o": 263, "f": 0 }, { "o": 261, "f": 0 }, { "o": 260, "f": 0 }, { "o": 259, "f": 0 }, { "o": 258, "f": 0 }, { "o": 257, "f": 0 }, { "o": 256, "f": 0 }, { "o": 255, "f": 0 }, { "o": 254, "f": 0 }, { "o": 250, "f": 0 }, { "o": 248, "f": 0 }, { "o": 247, "f": 0 }, { "o": 246, "f": 0 }, { "o": 244, "f": 0 }, { "o": 243, "f": 0 }, { "o": 242, "f": 0 }, { "o": 241, "f": 0 }, { "o": 240, "f": 0 }, { "o": 238, "f": 0 }, { "o": 237, "f": 0 }, { "o": 235, "f": 0 }, { "o": 234, "f": 0 }, { "o": 233, "f": 0 }, { "o": 229, "f": 0 }, { "o": 228, "f": 0 }, { "o": 226, "f": 0 }, { "o": 225, "f": 0 }, { "o": 224, "f": 0 }, { "o": 223, "f": 0 }, { "o": 220, "f": 0 }, { "o": 198, "f": 0 }, { "o": 197, "f": 0 }, { "o": 195, "f": 0 }, { "o": 194, "f": 0 }, { "o": 193, "f": 0 }, { "o": 192, "f": 0 }, { "o": 191, "f": 0 }, { "o": 187, "f": 0 }, { "o": 186, "f": 0 }, { "o": 185, "f": 0 }, { "o": 184, "f": 0 }, { "o": 183, "f": 0 }, { "o": 182, "f": 0 }, { "o": 179, "f": 0 }, { "o": 178, "f": 0 }, { "o": 176, "f": 0 }, { "o": 175, "f": 0 }, { "o": 174, "f": 0 }, { "o": 173, "f": 0 }, { "o": 172, "f": 0 }, { "o": 167, "f": 0 }, { "o": 166, "f": 0 }, { "o": 165, "f": 0 }, { "o": 164, "f": 0 }, { "o": 163, "f": 0 }, { "o": 162, "f": 0 }, { "o": 158, "f": 0 }, { "o": 157, "f": 0 }, { "o": 156, "f": 0 }, { "o": 155, "f": 0 }, { "o": 154, "f": 0 }, { "o": 153, "f": 0 }, { "o": 152, "f": 0 }, { "o": 146, "f": 0 }, { "o": 145, "f": 0 }, { "o": 144, "f": 0 }, { "o": 143, "f": 0 }, { "o": 142, "f": 0 }, { "o": 139, "f": 0 }, { "o": 138, "f": 0 }, { "o": 137, "f": 0 }, { "o": 136, "f": 0 }, { "o": 135, "f": 0 }, { "o": 134, "f": 0 }, { "o": 133, "f": 0 }, { "o": 126, "f": 0 }, { "o": 125, "f": 0 }, { "o": 124, "f": 0 }, { "o": 123, "f": 0 }, { "o": 120, "f": 1 }, { "o": 99, "f": 0 }, { "o": 98, "f": 0 }, { "o": 97, "f": 0 }, { "o": 96, "f": 0 }, { "o": 95, "f": 0 }, { "o": 93, "f": 0 }, { "o": 92, "f": 0 }, { "o": 90, "f": 1 }, { "o": 89, "f": 0 }, { "o": 88, "f": 0 }, { "o": 87, "f": 0 }, { "o": 86, "f": 0 }, { "o": 84, "f": 0 }, { "o": 83, "f": 0 }, { "o": 82, "f": 0 }, { "o": 80, "f": 1 }, { "o": 79, "f": 0 }, { "o": 78, "f": 0 }, { "o": 77, "f": 0 }, { "o": 76, "f": 0 }, { "o": 75, "f": 0 }, { "o": 73, "f": 0 }, { "o": 72, "f": 0 }, { "o": 70, "f": 1 }, { "o": 60, "f": 1 }, { "o": 59, "f": 0 }, { "o": 58, "f": 0 }, { "o": 55, "f": 0 }, { "o": 54, "f": 0 }, { "o": 53, "f": 0 }, { "o": 52, "f": 0 }, { "o": 50, "f": 1 }, { "o": 49, "f": 0 }, { "o": 48, "f": 0 }, { "o": 47, "f": 0 }, { "o": 46, "f": 0 }, { "o": 45, "f": 0 }, { "o": 44, "f": 0 }, { "o": 43, "f": 0 }, { "o": 42, "f": 0 }, { "o": 29, "f": 0 }, { "o": 28, "f": 0 }, { "o": 27, "f": 0 }, { "o": 26, "f": 0 }, { "o": 25, "f": 0 }, { "o": 24, "f": 0 }, { "o": 23, "f": 0 }, { "o": 22, "f": 0 }, { "o": 20, "f": 1 }, { "o": 19, "f": 0 }, { "o": 18, "f": 0 }, { "o": 17, "f": 0 }, { "o": 15, "f": 0 }, { "o": 11, "f": 0 }, { "o": 6, "f": 0 }, { "o": 4, "f": 0 }, { "o": 3, "f": 0 }];

				_.each( data, function ( val )
				{
					var re = new RegExp( "^0" + val.o );
					if ( nums.match( re ) )
					{
						if ( ( val.f && nums.length == 10 ) || ( !val.f && nums.length == 11 ) )
						{
							return false;
						}

						//ハイフンチェックがONなら

						if ( opt.checkDash )
						{
							var str = new String( val.o );
							switch ( str.length )
							{
								case 4:
									nums = nums.replace( /(\w{5})(\w{1})(\w{4})/, "$1-$2-$3" );
									break;
								case 3:
									nums = ( val.f ) ? nums.replace( /(\w{4})(\w{3})(\w{3})/, "$1-$2-$3" ) : nums.replace( /(\w{4})(\w{2})(\w{4})/, "$1-$2-$3" );
									break;
								case 2:
									nums = ( val.f ) ? nums.replace( /(\w{3})(\w{4})(\w{4})/, "$1-$2-$3" ) : nums.replace( /(\w{3})(\w{3})(\w{4})/, "$1-$2-$3" );
									break;
								case 1:
									nums = nums.replace( /(\w{2})(\w{4})(\w{4})/, "$1-$2-$3" );
									break;
							}
						}
					}
				});
			}
			else
			{
				return -1;
			}
		}
		else
		{
			return false;
		}
		return true;
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  全角にする( Unicode用 )
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.string.toZen = function ()
	{
		//半角英数を全角英数に
		var str = this.replace( /[!-~]/g, function ( s )
		{
			return String.fromCharCode( s.charCodeAt( 0 ) + 0xFEE0 );
		});

		var han = [ "ｶﾞ", "ｷﾞ", "ｸﾞ", "ｹﾞ", "ｺﾞ", "ｻﾞ", "ｼﾞ", "ｽﾞ", "ｾﾞ", "ｿﾞ", "ﾀﾞ", "ﾁﾞ", "ﾂﾞ", "ﾃﾞ", "ﾄﾞ", "ﾊﾞ", "ﾊﾟ", "ﾋﾞ", "ﾋﾟ", "ﾌﾞ", "ﾌﾟ", "ﾍﾞ", "ﾍﾟ", "ﾎﾞ", "ﾎﾟ", "ｳﾞ", "ｧ", "ｱ", "ｨ", "ｲ", "ｩ", "ｳ", "ｪ", "ｴ", "ｫ", "ｵ", "ｶ", "ｷ", "ｸ", "ｹ", "ｺ", "ｻ", "ｼ", "ｽ", "ｾ", "ｿ", "ﾀ", "ﾁ", "ｯ", "ﾂ", "ﾃ", "ﾄ", "ﾅ", "ﾆ", "ﾇ", "ﾈ", "ﾉ", "ﾊ", "ﾋ", "ﾌ", "ﾍ", "ﾎ", "ﾏ", "ﾐ", "ﾑ", "ﾒ", "ﾓ", "ｬ", "ﾔ", "ｭ", "ﾕ", "ｮ", "ﾖ", "ﾗ", "ﾘ", "ﾙ", "ﾚ", "ﾛ", "ﾜ", "ｦ", "ﾝ", "｡", "｢", "｣", "､", "･", "ｰ", "ﾞ", "ﾟ" ];
		var zen = [ "ガ", "ギ", "グ", "ゲ", "ゴ", "ザ", "ジ", "ズ", "ゼ", "ゾ", "ダ", "ヂ", "ヅ", "デ", "ド", "バ", "パ", "ビ", "ピ", "ブ", "プ", "ベ", "ペ", "ボ", "ポ", "ヴ", "ァ", "ア", "ィ", "イ", "ゥ", "ウ", "ェ", "エ", "ォ", "オ", "カ", "キ", "ク", "ケ", "コ", "サ", "シ", "ス", "セ", "ソ", "タ", "チ", "ッ", "ツ", "テ", "ト", "ナ", "ニ", "ヌ", "ネ", "ノ", "ハ", "ヒ", "フ", "ヘ", "ホ", "マ", "ミ", "ム", "メ", "モ", "ャ", "ヤ", "ュ", "ユ", "ョ", "ヨ", "ラ", "リ", "ル", "レ", "ロ", "ワ", "ヲ", "ン", "。", "「", "」", "、", "・", "ー", "゛", "゜" ];

		//半角カタカナがある場合

		while ( str.match( /[ｦ-ﾝ]/ ) )
		{
			//半角カナを全角カナに
			for ( var i = 0, len = han.length; i < len; i++ )
			{
				str = str.replace( han[ i ], zen[ i ] );
			}
		}

		return str;
	};

	implement.string.toKatakana = function ()
	{
		function isHiraganaCode( c )
		{
			return ( ( c >= 12353 && c <= 12435 ) || c == 12445 || c == 12446 );
		}

		// 引数のチェック
		if ( this == null )
			return "";

		var str = new String;
		var len = this.length;
		for ( var i = 0; i < len; i++ )
		{
			var c = this.charCodeAt( i );
			if ( isHiraganaCode( c ) )
				str += String.fromCharCode( c + 96 ); // ひらがなをカタカナに変換する
			else
				str += this.charAt( i );
		}

		return str;
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  数値へ変換  例："123".toInt();
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.string.toInt = function ( def )
	{
		if ( !Number.isFinite( def ) ) def = NaN;
		var i = parseInt( this.replace( /[^-0-9]/g, "" ), 10 );
		if ( Number.isFinite( i ) )
			return i;
		else
			return def;
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  "rgb(255,255,255)".rgb2hex() で FFFFFFを返す。
	//  "rgba(255,255,255,0.5)".rgb2hex() で FFFFFFと透明度情報(opacityとalpha)を返す。
	//  htmlプロパティで#付きの#FFFFFFを返す。
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.string.rgb2hex = function ()
	{
		try
		{
			var rgb = this.match( /^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,?[\s+]?([\.\d]+)?[\s+]?\)/i );
			var hex = ( rgb && rgb.length >= 4 ) ?
				( "0" + parseInt( rgb[ 1 ], 10 ).toString( 16 ) ).slice( -2 ) +
				( "0" + parseInt( rgb[ 2 ], 10 ).toString( 16 ) ).slice( -2 ) +
				( "0" + parseInt( rgb[ 3 ], 10 ).toString( 16 ) ).slice( -2 ) : '';

			var obj = new String( hex );
			if ( rgb && rgb.length === 5 && rgb[ 4 ] )
			{
				obj.opacity = parseFloat( rgb[ 4 ] );
			}
			else
			{
				obj.opacity = 1.0;
			}
			obj.alpha = obj.opacity;
			obj.html = '#' + hex;

			var opa = ( "0" + Math.floor( 255 * obj.opacity ).toString( 16 ) ).slice( -2 );
			obj.ie = {
				opacity: opa
				, alpha: opa
				, html: '#' + opa + hex
				, filter: 'progid:DXImageTransform.Microsoft.gradient(startColorstr=#' + opa + hex + ',endColorstr=#' + opa + hex + ');'
			};
			return obj;
		} catch ( exp )
		{
			return this;
		}
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//   HTMLエスケープ

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.string.htmlEscape = function ()
	{
		return this.replace( /[&<>"']/g, function ( m )
		{
			return "&#" + m.charCodeAt( 0 ) + ';'
		});
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  HTMLアンエスケープ（タグに戻す）

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.string.htmlUnescape = function ()
	{
		return this.replace( /&#([a-fA-F0-9]+);/g, function ( matchedString, group1 )
		{
			return String.fromCharCode( parseInt( group1, 10 ) );
		});
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  ファイルサイズ容量表示
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.string.datasize = function ()
	{
		return new Number( this ).datasize();
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  郵便番号にハイフンを入れる
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.string.formatZip = function ()
	{
		if ( this && global.isFinite( this ) && this.length == 7 ) return this.substr( 0, 3 ) + '-' + this.substr( 3 );
		return this;
	}
	implement.string.valZip = function ()
	{
		return this.replaceAll( '\-', '' ).trim();
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  電話番号をハイフン付にする
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.string.formatTel = function ()
	{
		//電話番号rule定義
		var rule1 = /^0471|0429|04200|04709|04700/;
		var rule2 = /^0120|0990|0180|0570|0170/;
		var rule3 = /^050|060|070|080|090/;
		var rule4 = /^09969|09913|09912|09802|09496|08514|08512|08477|08396|08388|08387|07468|05979|05769|04998|04996|04994|04992|01658|01656|01655|01654|01648|01635|01634|01632|01587|01586|01564|01558|01547|01466|01457|01456|01398|01397|01392|01377|01374|01372|01267|0997|0996|0995|0994|0993|0987|0986|0985|0984|0983|0982|0980|0979|0978|0977|0974|0973|0972|0969|0968|0967|0966|0965|0964|0959|0957|0956|0955|0954|0952|0950|0949|0948|0947|0946|0944|0943|0942|0940|0930|0920|0898|0897|0896|0895|0894|0893|0892|0889|0887|0885|0884|0883|0880|0879|0877|0875|0869|0868|0867|0866|0865|0863|0859|0858|0857|0856|0855|0854|0853|0852|0848|0847|0846|0845|0838|0837|0836|0835|0834|0833|0829|0827|0826|0824|0823|0820|0799|0798|0797|0796|0795|0794|0791|0790|0779|0778|0776|0774|0773|0772|0771|0770|0768|0767|0766|0765|0763|0761|0749|0748|0747|0746|0745|0744|0743|0742|0740|0739|0738|0737|0736|0735|0725|0721|0599|0598|0597|0596|0595|0594|0587|0586|0585|0584|0581|0578|0577|0576|0575|0574|0573|0572|0569|0568|0567|0566|0565|0564|0563|0562|0561|0558|0557|0556|0555|0554|0553|0551|0550|0548|0547|0545|0544|0539|0538|0537|0536|0533|0532|0531|0495|0494|0493|0480|0479|0478|0476|0475|0470|0467|0466|0465|0463|0460|0439|0438|0436|0428|0422|0299|0297|0296|0295|0294|0293|0291|0289|0288|0287|0285|0284|0283|0282|0280|0279|0278|0277|0276|0274|0270|0269|0268|0267|0266|0265|0264|0263|0261|0260|0259|0258|0257|0256|0255|0254|0250|0248|0247|0246|0244|0243|0242|0241|0240|0238|0237|0235|0234|0233|0229|0228|0226|0225|0224|0223|0220|0198|0197|0195|0194|0193|0192|0191|0187|0186|0185|0184|0183|0182|0179|0178|0176|0175|0174|0173|0172|0167|0166|0165|0164|0163|0162|0158|0157|0156|0155|0154|0153|0152|0146|0145|0144|0143|0142|0139|0138|0137|0136|0135|0134|0133|0126|0125|0124|0123|099|098|097|096|095|093|092|089|088|087|086|084|083|082|079|078|077|076|075|073|072|059|058|055|054|053|052|049|048|047|046|045|044|043|042|029|028|027|026|025|024|023|022|019|018|017|015|011|06|04|03/;

		//いったん余分な文字を除去
		var value = this.replaceAll( '　', '' ).replaceAll( ' ', '' ).replaceAll( '-', '' ).replaceAll( '‐', '' ).replaceAll( '―', '' ).replaceAll( '－', '' );
		if ( !value ) return '';

		try
		{
			if ( rule1.test( value ) )
			{
				// 埼玉とか千葉のややこしい"04-"のルール http://www.wdic.org/w/WDIC/04
				return ( value.substr( 0, 2 ) + "-" + value.substr( 2, 4 ) + "-" + value.substr( 6, 4 ) );
			}
			else if ( rule2.test( value ) )
			{
				// フリーダイヤル等は先に 0120-137789
				return ( value.substr( 0, 4 ) + "-" + value.substr( 4 ) );
			}
			else if ( rule3.test( value ) )
			{
				// 携帯 etc 0x0-1234-5678
				return ( value.substr( 0, 3 ) + "-" + value.substr( 3, 4 ) + "-" + value.substr( 7, 4 ) );
			}

			//2014-04 現在の総務省データ http://www.soumu.go.jp/main_sosiki/joho_tsusin/top/tel_number/shigai_list.html
			//EXCELで文字列で逆順ソートして、長いやつが先にヒットするように並べて重複は削除。
			var info = rule4.exec( value );
			if ( info )
			{
				if ( info[ 0 ].length == 5 )
				{
					// 01374-5-6789
					return ( value.substr( 0, 5 ) + "-" + value.substr( 5, 1 ) + "-" + value.substr( 6, 4 ) );
				}
				else if ( info[ 0 ].length == 4 )
				{
					// 0123-45-6789
					return ( value.substr( 0, 4 ) + "-" + value.substr( 4, 2 ) + "-" + value.substr( 6, 4 ) );
				}
				else if ( info[ 0 ].length == 3 )
				{
					// 011-234-5678
					return ( value.substr( 0, 3 ) + "-" + value.substr( 3, 3 ) + "-" + value.substr( 6, 4 ) );
				}
				else if ( info[ 0 ].length == 2 )
				{
					// 03-1234-5678
					return ( value.substr( 0, 2 ) + "-" + value.substr( 2, 4 ) + "-" + value.substr( 6, 4 ) );
				}
			}
		} catch ( ex )
		{
			return this;
		} return ( value );
	}

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  ファイル名を拡張子とそれ以外に分ける
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.string.splitExt = function ()
	{
		return this.split( /\.(?=[^.]+$)/ ); //this.split(/(?=\.[^.]+$)/); ←はドットを含める場合

	}

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  MIME TYPEから拡張子を求める
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.string.mime2ext = function ()
	{
		var MIME_TYPE = this;
		switch ( MIME_TYPE.toLowerCase() )
		{
			case 'application/x-javascript':
				return 'js';
			case 'application/json':
				return 'json';
			case 'image/jpg':
			case 'image/jpeg':
				return 'jpg';
			case 'image/png':
				return 'png';
			case 'image/gif':
				return 'gif';
			case 'image/bmp':
				return 'bmp';
			case 'image/tiff':
				return 'tif';
			case 'text/css':
				return 'css';
			case 'application/xml':
				return 'xml';
			case 'application/msword':
				return 'doc';
			case 'application/vnd.ms-excel':
				return 'xls';
			case 'application/vnd.ms-powerpoint':
				return 'ppt';
			case 'application/rtf':
				return 'rtf';
			case 'text/plain':
				return 'txt';
			case 'text/html':
				return 'html';
			case 'video/mpeg':
				return 'mpeg';
			case 'audio/mpeg3':
				return 'mp3';
			case 'audio/wav':
				return 'wav';
			case 'audio/aiff':
				return 'aif';
			case 'video/msvideo':
				return 'avi';
			case 'video/x-ms-wmv':
				return 'wmv';
			case 'video/quicktime':
				return 'mov';
			case 'application/zip':
				return 'zip';
			case 'application/x-tar':
				return 'tar';
			case 'application/x-shockwave-flash':
				return 'swf';
			default:
				return '';
		}
	}
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  タグ除去
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.string.removeTag = function ()
	{
		var elem = document.createElement( 'DIV' );
		elem.innerHTML = this;
		return elem.textContent ? elem.textContent : elem.innerText; //IEぇ…がinnerText
	}

	//==============================================
	// number型
	//==============================================
	implement.number.noop = $.noop;

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  ゼロパディングNumber版  例：new Number(123).zero(10);
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.number.zero = function ()
	{
		return new String( this ).zero( arguments[ 0 ] );
	}

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  ファイルサイズ容量表示
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.number.datasize = function ()
	{
		var point = 2; // 小数点以下の何桁で表示するか

		var tani = new Array( "GB", "MB", "KB", "Byte" );
		var str = 0;

		for ( var i = 0, j = 1073741824, len = tani.length; i < len; i++ , j /= 1024 )
		{
			if ( this >= j )
			{
				str = Math.floor( this * Math.pow( 10, point ) / j ) / Math.pow( 10, point ) + tani[ i ];
				return new String( str );
			}
		}
		return new String( this ) + "Byte";
	}

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//   カンマ区切りの数値フォーマットに変換
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.number.format = function ()
	{
		//うっかり混ざってるかもしれないカンマを消す
		var value = this.toString().replace( /,/g, '' );
		//整数に変換したのち文字列に戻す

		//この時点で数字とマイナス記号だけが残る
		if ( Number.isNaN( parseInt( value ) ) )
			throw new Error();

		var num = parseInt( value ).toString();

		//正規表現で桁区切りするための良く見かける関数的な何か
		//変数 num の中身が、桁区切りされる

		while ( num != ( num = num.replace( /^(-?\d+)(\d{3})/, "$1,$2" ) ) );

		//numに入っている値が数値じゃないときは0とする
		if ( Number.isNaN( parseInt( num ) ) ) num = 0;

		//桁区切りした結果（変数 num）でテキストボックスの中身を書き換える
		return num;
	}

	//==============================================
	// boolean型
	//==============================================

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//   ただの静的関数でBoolean型へチェンジ用
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.boolean.val = function ( _val )
	{
		if ( _val && typeof _val === 'string' )
			return _val.boolean();
		else
			return false;
	}

	//==============================================
	// jQuery拡張
	//==============================================

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  ユーザー環境判定
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.jquery.UA = ( function ()
	{
		var ua = navigator.userAgent;
		var win = global;
		var doc = document;

		var myStart = 0,
			myEnd = 0;

		function getVer( myKey )
		{
			myStart = ua.indexOf( myKey ) + myKey.length;
			myEnd = ua.indexOf( " ", myStart );
			if ( myEnd == -1 ) myEnd = ua.indexOf( ";", myStart );
			if ( myEnd > -1 )
				return ua.substring( myStart, myEnd );
			else
				return ua.substring( myStart );
		};

		var obj = {
			Trident: doc.uniqueID
			, Webkit: !win.chrome && 'WebkitAppearance' in doc.documentElement.style
			, Gecko: 'MozAppearance' in doc.documentElement.style
			, Blink: win.chrome
			, Safari: !win.chrome && 'WebkitAppearance' in doc.documentElement.style
			, Chrome: win.chrome
			, IE6: typeof win.addEventListener == "undefined" && typeof doc.documentElement.style.maxHeight == "undefined"
			, IE7: typeof win.addEventListener == "undefined" && ( doc.documentMode == 7 || ( typeof doc.documentElement.style.maxHeight != "undefined" && typeof doc.documentMode == "undefined" ) )
			, IE8: typeof win.addEventListener == "undefined" && doc.documentMode == 8
			, IE9: doc.uniqueID && doc.documentMode == 9
			, IE10: doc.uniqueID && doc.documentMode == 10
			, IE11: doc.uniqueID && doc.documentMode == 11
			, IE: doc.uniqueID
			, Firefox: 'MozAppearance' in doc.documentElement.style
			, Opera: win.opera
			, Mobile: typeof win.orientation != "undefined"
			, BB: ua.match( /(BlackBerry)/i )
			, iOS: ua.match( /(iPad|iPhone|iPod)/i )
			, iPhone: ua.match( /iPhone/i )
			, iPad: ua.match( /iPad/i )
			, Android: ua.indexOf( "Android" ) != -1
			, Touch: typeof doc.ontouchstart != "undefined"
		};

		if ( obj.Android )
			obj.Ver = ua.substr( ua.indexOf( "Android" ) + 8, 3 ) - 0;
		else if ( obj.IE )
			obj.Ver = doc.documentMode ? doc.documentMode : getVer( 'MSIE;' );
		else if ( obj.Opera )
			obj.Ver = getVer( 'Opera/' );
		else if ( obj.Firefox )
			obj.Ver = getVer( 'Firefox/' );
		else if ( obj.Chrome )
			obj.Ver = getVer( 'Chrome/' );
		else if ( obj.Safari )
			obj.Ver = getVer( 'Version/' );

		obj.Modern = ( obj.IE10 || obj.IE11 || obj.Firefox || obj.Opera || obj.iOS || obj.iPad || obj.Webkit );
		obj.PC = ( !obj.iOS && !obj.Mobile && !obj.BB );

		if ( obj.iOS )
		{
			if ( ua.indexOf( "iPhone OS" ) == -1 )
			{
				ua.match( /CPU OS (\w+){1,3}/g )
			} else
			{
				ua.match( /iPhone OS (\w+){1,3}/g )
			}
			var revision = ( RegExp.$1.replace( /_/g, "" ) + "00" ).slice( 0, 3 );
			obj.Ver = ( revision >= 100 && revision < 200 ) ? 1 :
				( revision >= 200 && revision < 300 ) ? 2 :
					( revision >= 300 && revision < 400 ) ? 3 :
						( revision >= 400 && revision < 500 ) ? 4 :
							( revision >= 500 && revision < 600 ) ? 5 :
								( revision >= 600 && revision < 700 ) ? 6 :
									( revision >= 700 && revision < 800 ) ? 7 :
										( revision >= 800 && revision < 900 ) ? 8 :
											( revision >= 900 && revision < 1000 ) ? 9 : null;

			if ( obj.iPad )
			{
				obj.Mobile = false;
				obj.PC = true;
			}
			else
			{
				obj.Mobile = true;
				obj.PC = false;
			}
		}
		obj.Tablet = ( obj.Android && !obj.Mobile ) || ( obj.iPad ) || ( obj.PC && typeof win.orientation != "undefined" );

		return obj;
	})()
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  URLパース
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.jquery.uri = function ( _url )
	{
		var decode = decodeURIComponent;
		var prop = [ 'hash', 'host', 'hostname', 'href', 'pathname', 'port', 'protocol', 'search' ];
		var loc = _url
			? $( '<a />' ).prop( 'href', _url )[ 0 ]
			: location;
		var ret = {};
		_.each( prop, function ( n, i )
		{
			//var n = prop[i];
			if ( typeof loc[ n ] == 'string' )
			{
				if ( n == 'pathname' && loc[ n ].charAt( 0 ) != '/' )
					ret[ n ] = '/' + loc[ n ];
				else
					ret[ n ] = loc[ n ];
			}
		});
		var q = ret.param = {};
		if ( ret.search )
		{
			var s = ret.search.substr( 1 ).split( '&' );
			_.each( s, function ( k, i )
			{
				var p = s[ i ].split( '=' );
				var v = p[ 1 ];
				try
				{
					v = decode( v );
				} catch ( e ) { }
				q[ p[ 0 ] ] = v;
			});
		}
		if ( ret.hash )
		{
			ret.fragment = ret.hash;
			var vars = ret.hash.substr( 1 ).split( '&' );
			if ( vars.length > 0 )
			{
				ret.hash = {};
				ret.hash[ 0 ] = ret.fragment;
				for ( var i = 0, len = vars.length; i < len; i++ )
				{
					var sets = vars[ i ].split( '=' );
					if ( sets.length == 2 )
					{
						var key = sets[ 0 ];
						ret.hash[ key ] = decode( sets[ 1 ] );
					}
					else
					{
						ret.hash = decode( vars[ i ] );
					}
				};
			}
		}
		return ret;
	}
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  初回アクセス判定

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.jquery.isFirstAccess = function ()
	{
		if ( global.sessionStorage && typeof $.sessionStorage != 'undefined' )
		{
			//ローカルストレージが使えるならば
			if ( $.sessionStorage.getItem( "ses" ) != "1" )
			{
				//log( 'isFirstAccess', true );
				return true;
			}
			else
			{
				//log( 'isFirstAccess', false );
				return false;
			}
		}
		else if ( $.cookie( "ses" ) != "1" )
		{
			//クッキーでチェック
			//log( 'isFirstAccess', true );
			return true;
		}

		//log( 'isFirstAccess', false );
		return false;
	}

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  セッション管理用 html5::sessionStorageを使っているのでスマホのWEBアプリでも使える
	//  html5::sessionStorage非対応の端末・ブラウザではcookieで対応
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.jquery.setSession = function ( key, val, opt )
	{
		var def = { path: '/' };
		var setting = $.extend( true, {}, def, opt );

		if ( global.sessionStorage && typeof $.sessionStorage != 'undefined' )
		{
			$.sessionStorage.setItem( key, val, setting );
		}
		$.cookie( key, val, setting );
	}

	implement.jquery.getSession = function ( key, opt )
	{
		var def = { path: '/' };
		var setting = $.extend( true, {}, def, opt );

		if ( global.sessionStorage && typeof $.sessionStorage != 'undefined' )
		{
			return $.sessionStorage.getItem( key, setting );
		}
		return $.cookie( key );
	}

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	// NVL関数  $.nvl( A, B, C, D, 'default' )
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	// implement.jquery.nvl = function ()
	// {
	// 	//nvlは可変長引数対応なのでapply()で。
	// 	return global.nvl.apply( this, arguments );
	// }
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  高速非同期呼び出し 使い方：$.async( func );
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.jquery.async = function ( callback )
	{
		var img = new Image;
		if ( typeof img.addEventListener === 'undefined' )
			img.attachEvent( 'onerror', callback ); // for IE8以下

		else
			img.addEventListener( 'error', callback, false );
		img.src = 'data:,undefined';
	}
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  window.alert使ってると意味ない
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.jquery.alert = function ( _msg )
	{
		global.alert( _msg );
	}

	/**
	 * スクロール時にマウスオーバーイベントをブロックし、描画負荷を軽減させるし、
	 * ページスクロール中にインラインスクロールな要素に出会っても邪魔されない機能
	 */
	implement.jquery.noopScroll = function ()
	{
		if( $.UA.IE && $.UA.Ver <= 8 ) return ; //EXIT IE8以下は透過が馬鹿だから無視
		if( $( '#EyesMouseBlocker' ).get( 0 ) ) return; //EXIT

		global.isBlocking = false;
		const $block = $( $.parseHTML( '<div id="EyesMouseBlocker" style="display:none;position:fixed;height:100%;width:100%;top:0;left:0;opacity:0;background-color:red;z-index:2000000001;"></div>' ) ).prependTo( 'body' );
		$block.on( 'mouseenter', function ( evt ) { return $.eventStop( evt ); })

		const blocker = function blocker()
		{
			global.isBlocking = true;
			$block.show();
			//console.log('blocker',new Date());
		}

		const unblocker = _.debounce( function ()
		{
			global.isBlocking = false;
			$block.hide();
			//console.log('unblocker', new Date());
		}, 16 * 7, false );

		$( global ).on( 'scroll', function ( evt )
		{
			if ( false === global.isBlocking ) blocker();
			unblocker();
		});
	}

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	// ページ離脱処理（ブラウザ閉じたり、ページを離れる時に表示するアラートメッセージを仕込む）

	// $.execBeforeUnloadをfalseにするとアラートは出さない

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.jquery.beforeunload = function ( _msg )
	{
		$.execBeforeUnload = !!_msg;

		$( document ).ready( function ()
		{
			$( 'a' ).click( function ( evt )
			{
				//javascriptが記載されている場合はキャンセルフラグを一瞬立てて戻す。

				if ( evt.target.href && evt.target.href.indexOf( "javascript" ) === 0 )
				{
					$.cancelBeforeUnload();
				}
			});
		});

		$( global ).on( 'beforeunload', function ( evt )
		{
			if ( $.execBeforeUnload && _msg )
			{
				evt.stopPropagation();
				evt.preventDefault();
				return _msg;
			}
		});
	}
	implement.jquery.execBeforeUnload = false
	implement.jquery.cancelBeforeUnload = function ()
	{
		$.execBeforeUnload = false;
		setTimeout( function ()
		{
			$.execBeforeUnload = true;
		}, 1 );
	}

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	// ブラウザの言語情報 * RFC 4646の先頭2文字(ISO 639)を取得

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.jquery.getLang = function ()
	{
		try
		{
			//URL引数から言語設定を取得

			var urlobj = $.uri( location.href );
			var lang = urlobj.param.lang;
			if ( lang != null && lang.length == 2 )
			{
				//log('lang url:',lang);
				$.cookie( 'lang', lang, { path: '/' });
				return lang;
			}

			//クッキーから言語設定を取得

			lang = $.cookie( 'lang' );
			if ( lang != null && lang.length == 2 )
			{
				//log('lang cookie:',lang);
				return lang;
			}

			//初回はブラウザの言語設定を利用
			//log('lang browser:',lang);
			return ( navigator.browserLanguage || navigator.language || navigator.userLanguage ).substr( 0, 2 ).toLowerCase();
		}
		catch ( e )
		{
			return 'ja';
		}
	}
	implement.jquery.sleep = function ( time, func, args )
	{
		return ( function ()
		{
			if ( !time ) time = 100;
			var dfd = $.Deferred();
			setTimeout( function ()
			{
				if ( func && $.isFunction( func ) )
				{
					func.apply( this, args );
				}
				dfd.resolve();
			}, time );
			return dfd.promise();
		});
	}
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  電話番号チェック（ハイフンありなし両対応）
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.jquery.checkTel = function ( options )
	{
		var dfd = $.Deferred();

		//デフォルトオプション
		var def = {
			value: ''
			, checkDash: true //ハイフン正規化を行うか

			, message0: '電話番号を入力してください。' //桁間違い時のメッセージ
			, message1: '電話番号の桁数が違います。' //桁間違い時のメッセージ
			, message2: '電話番号の先頭は0です。' //先頭間違い

		};

		//引数をvalueとしてチェックする
		if ( $.type( options ) !== 'object' )
			options = { value: options };

		//オプションを取得する

		var opt = $.extend( true, {}, def, options );
		var ret = opt.value.isTel( options );
		if ( ret === true )
		{
			return dfd.resolve( opt.value );
		}
		else if ( ret === null )
		{
			return dfd.reject( opt.message0 );
		}
		else if ( ret === false )
		{
			return dfd.reject( opt.message1 );
		}
		else if ( ret === -1 )
		{
			return dfd.reject( opt.message2 );
		}
		return dfd.resolve( opt.value );
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//   すべてのイベントに無反応な関数
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.jquery.eventStop = function ( evt )
	{
		if ( !evt ) return false;
		try { if ( evt.stopImmediatePropagation ) evt.stopImmediatePropagation(); } catch ( err ) { }
		try { if ( evt.preventDefault ) evt.preventDefault(); } catch ( err ) { }
		try { if ( evt.stopPropagation ) evt.stopPropagation(); } catch ( err ) { }
		return false;
	};

	//********************************************************************
	//                        プラグイン用メソッド
	//********************************************************************
	implement.jquery.fn = {};
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//描画要素なのか判定
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.jquery.fn.isVisible = function ()
	{
		return $.expr.filters.visible( this[ 0 ] );
	}

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//フォームをクリア（リセットではなく）
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.jquery.fn.clearForm = function ()
	{
		var $my = $( this );
		var $form = $my.prop( 'tagName' ) == 'FORM' ? $my : $my.closest( 'form' );

		if ( $form.get( 0 ) )
		{
			for ( var i = 0, len = $form.get( 0 ).elements.length; i < len; ++i )
			{
				clearElement( $form.get( 0 ).elements[ i ] );
			}
		}

		function clearElement( element )
		{
			switch ( element.type )
			{
				case "hidden":
				case "submit":
				case "reset":
				case "button":
				case "image":
					return;
				case "file":
					return;
				case "text":
				case "password":
				case "textarea":
					element.value = "";
					return;
				case "checkbox":
				case "radio":
					element.checked = false;
					return;
				case "select-one":
				case "select-multiple":
					element.selectedIndex = 0;
					return;
				default:
			}
		}
		return $form;
	}
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	// 対象要素内のインプット要素を全てdisabledに
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.jquery.fn.disabled = function ( arg )
	{
		return $( 'input,textarea,select,option,button', $( this ) ).prop( 'disabled', arg == null ? true : arg );
	}
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	// 対象要素内のインプット要素を全てreadonlyに
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.jquery.fn.readonly = function ( arg )
	{
		return $( 'input,textarea,select,option,button', $( this ) ).prop( 'readonly', arg == null ? true : arg );
	}
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	// val()のnvl
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.jquery.fn.nvl = function ()
	{
		//argumentsは正確には配列ではないので、配列として扱いたいならば「Array.prototype.slice.call(arguments)」
		var vals = Array.prototype.slice.call( arguments );

		//引数から入力値を排除した配列を用意
		vals.unshift( this.val() );

		for ( var i = 0, len = vals.length; i < len; i++ )
		{
			if ( typeof vals[ i ] === 'string' && vals[ i ].trim() != '' )
				return vals[ i ];
			else if ( typeof vals[ i ] === 'boolean' )
				return vals[ i ];
			else if ( typeof vals[ i ] === 'number' )
				return vals[ i ];
		}
		return this;
	}
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	// 自分自身のタグを取得

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.jquery.fn.selfHtml = function ()
	{
		if ( $( this ).get( 0 ) )
		{
			return $( this ).get( 0 ).outerHTML;
		}
		return this;
	}

	implement.ajax = {
		defer: function ( options )
		{
			return function ()
			{
				var dfd = $.Deferred();
				//Ajax送信処理を記述
				var defaults = {
					url: 'Set URL !!'
					, type: 'GET'
					, dataType: 'json'	// text,html,xml,script,json,jsonp のいずれか
					, async: true
					, crossDomain: true
					, scriptCharset: 'UTF-8'
					, cache: false
					, timeout: 60000
					, username: ''
					, password: ''
					, processData: true		//自動エンコード
					, beforeSend: function ()
					{
						//console.time('Ajax.load');
					}
					, complete: function ( xhr, status )
					{
						//console.timeEnd('Ajax.load');
					}
					, statusCode: {
						403: $.noop
						, 404: $.noop
						, 500: $.noop
						, 503: $.noop
						, 200: $.noop
					}
					, success: dfd.resolve
					, error: dfd.reject
				};

				if ( typeof options.cache !== 'boolean' && Number.isFinite( options.cache ) )
				{
					//独自でキャッシュ用引数をコントロール
					var cachetime = new Date / options.cache | 0;
					if ( cachetime === 0 )
					{
						options.cache = false; //キャッシュを効かせる

					}
					else
					{
						if ( options.data )
							options.data._ = cachetime;
						else
							options.data = { _: cachetime };
						options.cache = true; //キャッシュを効かせる

					}
				}
				$.ajax( $.extend( true, {}, defaults, options ) );
				return dfd.promise();
			};
		}
		, load: function ( options )
		{
			//log('load',options);
			return this.defer( options )();
		}
		, cacheTime: function ( time )
		{
			var _time = null;
			if ( Number.isFinite( time ) && Number.isFinite( _time = new Date / time ) )
			{
				return _time | Math.random();
			}
			else
			{
				return Math.random();
			}
		}
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  複数の入力項目で同期する
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.SyncGroup = function ()
	{
		/**
		 * @type {JQuery[]}
		 */
		this.members = [];
	};

	/**
	 * @param {string|JQuery|Element} query
	 */
	implement.SyncGroup.prototype.add = function ( query )
	{
		const $member = $( query );
		const members = this.members;
		members.push( $member );

		$member.on( 'change', function ( evt )
		{
			const val = $( evt.target ).val();
			_.each( members, function ( $elem )
			{
				if ( $elem.get( 0 ) !== evt.target )
				{
					$elem.val( val );
				}
			});
		});
	};

	/**
	 * ブラウザをリフローさせる
	 * http://tokkono.cute.coocan.jp/blog/slow/index.php/web-technology/reflow-and-repaint-in-browser/
	 */
	implement.forceLayout = function ( args )
	{
		//リフローさせる。このmethodが信用ならないならリペイントも発行できるセッター系のやつに変更してね
		document.getElementsByTagName( "body" )[ 0 ].offsetLeft;
		return $.Deferred().resolve( args );
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  破壊的なプロパティ名の大文字→小文字変換
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.toLowerProp = function toLowerProp( obj )
	{
		_.each( obj, function ( val, key, org )
		{
			if ( is( 'String', key ) )
			{
				var newkey = key.toLowerCase();
				delete org[ key ];
				org[ newkey ] = val;
			}

			if ( _.isArray( val ) )
			{
				_.each( val, function ( val )
				{
					implement.toLowerProp( val );
				});
			}
		});
	}

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//  アプリオブジェクト
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	const Application = function ()
	{
		this.ERROR = false;
		this.CODE_PATTERN = /^[-_.!*(|)a-z0-9]+$/i;		//キーコードパターン定義
		this.setting = {
			COOKIE_OPT: {
				expires: 365
				, path: '/'
			}

			//ローディング画面のデフォルト設定
			, LOADING_OPT: {
				mode: 'start'				// start / stop
				, id: 'pre-loading'			// ID
				, type: 'snake'				// snake , spin, corner, text, emoji
				, override: true					// 引数で与えた設定を覚えるモード true:繰り返し再設定する必要なし / false:常にここのデフォルト設定が初期値となる
				, zIndex: 2000000000			// 2000000000
				, fade: 1200					// フェード時間を指定できます。
				, opacity: 1						// 透明度 0～1
				, background: 'rgba(55, 55, 55, 0.46)'	// 背景色 ※IE8にも透過背景対応
				, text: 'しばらくお待ちください'
				, emoji: '&#xE806;'
				, context: 'body'
			}
		};
	};

	Application.prototype = {
		config: null,
		//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
		//   返却されたjsonオブジェクトにエラーが含まれているかチェック
		//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
		isError: function ( _json )
		{
			//log(_json);
			if ( _json && _json.errors && _json.errors.length > 0 )
			{
				//エラー表示
				var msg = '';
				for ( var i = 0; i < _json.errors.length; i++ )
					msg += '・ ' + _json.errors[ i ] + "\n";

				if ( msg ) $.alert( msg );
				this.ERROR = true;
			}
			return this.ERROR;
		},
		//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
		//   jsonで返却されたデータでアイテムを持っているか
		//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
		hasItems: function ( _json )
		{
			return _json && ( Array.isArray( _json ) && _json.length > 0 ) || ( !Array.isArray( _json ) && _json != null );
		},
		//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
		//   ローディング画面の制御
		//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
		nowLoading: function ( options )
		{
			var dfd = $.Deferred();
			var opt = $.extend( true, {}, App.setting.LOADING_OPT, options );	//上書きしません。初期値固定モード

			var is_stop = opt.mode.toLowerCase() == 'stop' || opt.mode.toLowerCase() == 'end' || !opt.mode;
			var $loading = $( '#' + opt.id );
			var isVelocity = !!$.Velocity;

			//なければ追加
			if ( $loading.length == 0 )
			{
				var $oya = $( opt.context ).eq(0);
				var isBody = $oya.prop('tagName').toUpperCase() == 'BODY';
				var css_position = isBody ? 'fixed' : 'absolute';

				if( !isBody && $oya.css('position').toLowerCase() == 'static' )
					$oya.css('position','relative');

				$loading = $( $.parseHTML( `<div id="${opt.id}" style="display:none;position:${css_position};top:0;left:0;bottom:0;right:0;"></div>` ) ).prependTo( $oya );
				$loading.css( 'opacity', opt.opacity );
				$loading.css( 'zIndex', opt.zIndex );

				if ( $.UA.IE && $.UA.Ver < 9 )
				{
					//IE8の場合 フィルターで透過を実装
					var hex = opt.background.rgb2hex();
					$loading.css( { 'filter': hex.ie.filter }) //IE Fallback
				}
				else
				{
					$loading.css( 'background-color', opt.background );
				}
			}

			//表示コントロール
			if ( is_stop )
			{
				//停止
				if ( $loading.children().length > 0 )
				{
					//子のオブジェクトが消えてから
					if( isVelocity )
					{
						$loading.children()
							.velocity('fadeOut', { duration: (opt.fade / 3 * 2), complete: function(){
								$loading.velocity('fadeOut', {duration : (opt.fade / 3), complete: function(){
									$loading.remove();
									return dfd.resolve( opt ); //EXIT
								}});
							}});
					}
					else
					{
						//子のオブジェクトが消えてから
						$loading.children()
							.fadeOut( opt.fade / 3 * 2, function ()
							{
								//全体をフェードアウト＆削除
								$loading.fadeOut( opt.fade / 3, function ()
								{
									$loading.remove();
									return dfd.resolve( opt ); //EXIT
								});
							});
						
					}
				}
				else
				{
					//子がいないなら直ちにフェードアウト＆削除
					if( isVelocity )
					{
						$loading.velocity('fadeOut', {duration : (opt.fade / 3), complete: function(){
							$loading.remove();
							return dfd.resolve( opt ); //EXIT
						}});
					}
					else
					{
						$loading.fadeOut( opt.fade / 3, function ()
						{
							$loading.remove();
							return dfd.resolve( opt ); //EXIT
						});
					}
				}
			}
			else
			{
				if ( opt.type.toLowerCase() == 'snake' && $loading.find( '.snake-loading' ).length == 0 )
					$loading.empty().append( '<div class="snake-loading" style="display:none;"><span></span><span></span><span></span><span></span><span></span></div>' );
				else if ( opt.type.toLowerCase() == 'corner' && $loading.find( '.corner-loading' ).length == 0 )
					$loading.empty().append( '<div class="corner-loading" style="display:none;"><hr/><hr/><hr/><hr/></div>' );
				else if ( opt.type.toLowerCase() == 'text' && $loading.find( '.text-loading' ).length == 0 )
				{
					var $content = $( '<div class="text-loading" style="display:none;"></div>' );
					$content.html( opt.text );
					$loading.empty().append( $content );
				}
				else if ( opt.type.toLowerCase() == 'spin' && $loading.find( '.spin-loading' ).length == 0 )
					$loading.empty().append( '<div class="spin-loading" style="display:none;"><div><div></div><div></div><div></div><div></div></div><div><div></div><div></div><div></div><div></div></div><div><div></div><div></div><div></div><div></div></div></div>' );
				else if ( opt.type.toLowerCase() == 'emoji' && $loading.find( '.emoji-loading' ).length == 0 )
					$loading.empty().append( '<div class="emoji-loading fa fa-spin" style="display:none;">' + opt.emoji + '</div>' );

				//開始
				if( isVelocity )
				{
					$loading
						.velocity('fadeIn', { duration: (opt.fade / 3), complete: function(){
							$loading.children().velocity('fadeIn', {duration : (opt.fade / 3 * 2), complete: function(){
								return dfd.resolve( opt ); //EXIT
							}});
						}});
				}
				else
				{
					$loading.fadeIn( opt.fade / 3, function ()
					{
						$loading.children().fadeIn( opt.fade / 3 * 2, function ()
						{
							return dfd.resolve( opt );
						});
					});
				}
			}

			return dfd.promise();
		},
	};
	implement.Application = new Application(); //インスタンス化しておく

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//   $.Deferred対応ローディング開始
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.loadingStart = function ( options )
	{
		var def = {
			mode: 'start'
		};
		var opt = $.extend( true, {}, def, options );
		opt.mode = 'start';

		if ( $.UA.IE && $.UA.Ver < 10 )
			opt.type = 'text';

		return implement.Application.nowLoading.call( this, opt );
	};

	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	//   $.Deferred対応ローディング終了
	//- - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
	implement.loadingEnd = function ( options )
	{
		var opt = $.extend( true, {}, options );
		opt.mode = 'stop';
		return implement.Application.nowLoading.call( this, opt );
	};

	return implement;
});
